import React from 'react'
import { Outlet } from 'react-router-dom'

import { NavBar } from '@components'
import { COMPANY_NAME, ROUTES, VERSION } from '@common'
import { useNavigate } from 'react-router-dom'

const NonAuthLayoutWrapper = props => {
    const navigate = useNavigate()

    const handleLongPress = () => {
        navigate(ROUTES.CheckoutAssistant.root)
    }

    return (
        <div className="dashboard-bg p-0 m-0">
            <div className="dashboard-page-content">
                <div className="d-flex flex-grow-1 flex-column">
                    <NavBar />
                    <div style={{ height: 56 }} />
                    <Outlet />
                </div>

                <div className="mt-auto">
                    <div className="text-center text-muted p-4">
                        <p className="mb-0">
                            &copy; {new Date().getFullYear()}，{COMPANY_NAME}
                        </p>
                        <p className="text-muted opacity-50 mb-0 mt-1 no-print" onClick={handleLongPress}>
                            v{VERSION}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NonAuthLayoutWrapper
